import React from "react";
import {Form} from "react-bootstrap";


const LocationPlaceSelectField = ({name, props}) => {
    // console.log({props});
    const {
        variables,
        setVariables, 
        fieldSettings, 
        fieldErrors, 
        } = props;
    
    
    
    const handleChange = e => {
        const {value} = e.target
        setVariables({...variables, [name]: value})
    }
        const {label, required, toolTip, options} = fieldSettings[name];
        const value = variables[name] || "";
    return(
        <Form.Group size="lg" controlId={name}>
            <Form.Label className ="pt-1 px-1" >{label}{required? ' * ':' '}</Form.Label>
            { fieldErrors[name]?<small > - {fieldErrors[name]}</small>:null}
            <Form.Control as="select"
                name={name} 
                type="select" 
                key={name} 
                value={value}
                onChange={(e) => handleChange(e)} 
            >
            {options?.map(opt => (
                        <option value= {opt.key} key={`${opt.key}_${opt.value}`}>{opt.value}</option>
                    ))}
            </Form.Control>
            {toolTip?<p><small className="text-black p-1" style={{backgroundColor:"rgba(255,255,255,.5"}}>{toolTip}</small></p>:null}
        </Form.Group>
    )
}
export default LocationPlaceSelectField;
